import { render, staticRenderFns } from "./fileMaxSize-editor.vue?vue&type=template&id=00a1b8e3&scoped=true&"
import script from "./fileMaxSize-editor.vue?vue&type=script&lang=js&"
export * from "./fileMaxSize-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a1b8e3",
  null
  
)

export default component.exports